import { html } from 'lit';
import { Purpose } from '@common/types/model';
import type { TefComs4p } from '@src/components/TefComs4p';
import { componentStateStore } from '@src/store';

//
// renders a single purpose block
//
// {Purpose name}
// {Purpose description}
//   {subscription BLOCK}
export const singlePurposeView = function render(this: TefComs4p, purpose : Purpose) {
  return html`
    <one-stack gap="xxs">
      <one-cluster noWrap gap="none" x="space-between">
        <one-heading level="h6" variant="default">${purpose.title}</one-heading>
        <one-button variant="plain" size="medium" type="button" @click=${() => this.editPurpose(purpose.purposeId)} ?disabled=${componentStateStore.disabled}>Ändern</one-button>
      </one-cluster>
      <one-text as="span">${purpose.shortDescription} ${this.getTemplateFn('tefPurposeDescriptionModal')(purpose)}</one-text>
    </one-stack>
  `;
};
